<template>
  <div id="app">
    <schedule-view />
  </div>
</template>

<script>
import ScheduleView from './views/ScheduleView.vue'

export default {
  name: 'App',
  components: { ScheduleView }
}
</script>

<style>
@import './assets/styles/global.css';
</style>
